import React, { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { useTimelineCustomComponents } from '../../../../controllers/timeline-custom-components/index.tsx';
import type { TimelineCellRenderer$key } from './__generated__/TimelineCellRenderer.graphql';

export type TimelineCellProps = {
	depth: number;
	groupId?: string;
	fieldRef: TimelineCellRenderer$key;
};

export const TimelineCellRenderer: FC<TimelineCellProps> = ({ depth, groupId, fieldRef }) => {
	const timelineCustomComponents = useTimelineCustomComponents();

	const data = useFragment<TimelineCellRenderer$key>(
		graphql`
			# eslint-disable-next-line @atlassian/relay/fragment-naming-convention
			fragment TimelineCellRenderer on JiraIssueField
			@argumentDefinitions(
				isTimelineEnabled: { type: "Boolean!" }
				isJiraTimelineRollupsTechnicalGateEnabled: {
					type: "Boolean!"
					provider: "@atlassian/jira-relay-provider/src/jira-timeline-rollups-technical-gate.relayprovider"
				}
			) {
				# eslint-disable-next-line @atlassian/relay/must-colocate-fragment-spreads
				...TimelineCell @include(if: $isTimelineEnabled)
				# eslint-disable-next-line @atlassian/relay/must-colocate-fragment-spreads
				...TimelineCell_AggregatedTimelineCell
					@include(if: $isJiraTimelineRollupsTechnicalGateEnabled)
			}
		`,
		fieldRef,
	);

	return (
		timelineCustomComponents?.Cell && (
			<timelineCustomComponents.Cell depth={depth} groupId={groupId} fieldRef={data} />
		)
	);
};
